import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';

export interface ItemType {
  label: string;
  pluralLabel: string;
  value: string;
  modelName: string;
  icon: any;
  manageLink?: string;
  supportsQuantity: boolean;
}

export const selectableItemTypes: ItemType[] = [
  {
    label: 'Package',
    pluralLabel: 'Packages',
    value: 'package',
    modelName: 'Fbm::Package',
    icon: icon({ name: 'box', style: 'regular' }),
    manageLink: undefined,
    supportsQuantity: false,
  },
  {
    label: 'Group',
    pluralLabel: 'Groups',
    value: 'group',
    modelName: 'Group',
    icon: icon({ name: 'users', style: 'regular' }),
    manageLink: '/groups',
    supportsQuantity: false,
  },
  {
    label: 'Plan',
    pluralLabel: 'Plans',
    value: 'plan',
    modelName: 'WorkoutPlan',
    icon: icon({ name: 'list-check', style: 'regular' }),
    manageLink: undefined,
    supportsQuantity: false,
  },
  {
    label: 'Product',
    pluralLabel: 'Products',
    value: 'product',
    modelName: 'Exercisecom::Product',
    icon: icon({ name: 'boxes-packing', style: 'regular' }),
    manageLink: undefined,
    supportsQuantity: true,
  },
  {
    label: 'Online Training',
    pluralLabel: 'Online Training',
    value: 'onlineTraining',
    modelName: 'onlineTraining',
    icon: icon({ name: 'globe', style: 'regular' }),
    manageLink: undefined,
    supportsQuantity: false,
  },
];
